import React, {Component} from "react";
import {setUserActive, setUserAuth, setUserData, setUserDebts, setUserToken} from "../../store/user/actions";
import {setTapBarData} from "../../store/tapBar/actions";
import {setBankTransferType, setCardTransferData} from "../../store/transfer/actions";
import {connect} from "react-redux";
import {withRouter} from "@happysanta/router";
import {Div} from "@vkontakte/vkui";
import axios from "../../axios/axios";
import EducationItem from "./EducationItem";
import {SERVER_CONFIG} from "../../config";


class EducationList extends Component {

    state = {
        educationList: []
    }



    render() {
        const educationList = this.state.educationList
        return (
            educationList.map((item, key) => {
                return (<EducationItem item={item} key={key}/>)
            })
        )
    }

    componentDidMount() {
      axios.get('education')
            .then(res => res.data)
            .then(res => this.setState({educationList: res}))

    }
}

const mapStateToProps = (state) => {
        return {
            user: state.user,
            tapBar: state.tapBar,
            transfer: state.transfer
        };
    }
;

const mapDispatchToProps =
    {
        setUserData,
        setUserAuth,
        setUserToken,
        setUserActive,
        setUserDebts,
        setTapBarData,
        setCardTransferData,
        setBankTransferType
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EducationList));